window._ = require('lodash');

// eslint-disable-next-line @typescript-eslint/no-var-requires
const jquery = require('jquery');

window.jQuery = jquery;
window.$ = jquery;

try {
  $.fn.editable.defaults.mode = 'popup';
  $.fn.editable.defaults.showbuttons = true;
  $.fn.editable.defaults.addEventListener('blur', 'cancel');
  $.fn.editableform.buttons =
    '<button type="submit" class="btn btn-primary btn-sm editable-submit">' +
    '<i class="v-icon mdi mdi-check"></i>' +
    '</button>' +
    '<button type="button" class="btn btn-default btn-sm editable-cancel">' +
    '<i class="v-icon mdi mdi-close"></i>' +
    '</button>';

  // eslint-disable-next-line global-require
  require('bootstrap-sass');
  // eslint-disable-next-line no-empty
} catch {}

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
